module.exports = __webpack_public_path__ + "img/check-circle.5d90a4e2.svg";